<template>
  <v-container>
    <div id="grid-pestanas">
      <v-toolbar card color="white">
        <v-toolbar-title class="indigo--text">Pestañas</v-toolbar-title>
        <v-btn color="primary" @click="crearPestana()"> Agregar</v-btn>
      </v-toolbar>

      <v-layout justify-center>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>

          <v-data-table
            :headers="headers"
            :items="datosPaginados"
            :search="search"
            :page.sync="page"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
            @page-count="pageCount = $event"
            hide-actions
          >
            <template v-slot:items="props">
              <td>{{ props.item.descripcion }}</td>
              <td>{{ props.item.orden }}</td>
              <td class="text-xs-left">
                {{ props.item.estado == true ? "Activada" : "Desactivada" }}
              </td>
              <td class="text-xs-left">{{ props.item.fechaCreacion }}</td>
              <td>
                <v-btn
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  title="Editar pestaña"
                  @click="
                    editarPestana(
                      props.item.id,
                      props.item.descripcion,
                      props.item.orden
                    )
                  "
                >
                  <v-icon>open_in_new</v-icon>
                </v-btn>
                <v-btn
                  v-if="props.item.estado == true  && getCodigoPerfil() !== 'LEC' && !isContratoCerrado()"
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="green darken-4"
                  small
                  title="Deshabilitar"
                  @click="cambiaEstado(props.item.id)"
                >
                  <v-icon>toggle_off</v-icon>
                </v-btn>
                <v-btn
                  v-if="props.item.estado == false   && getCodigoPerfil() !== 'LEC' && !isContratoCerrado()"
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="grey darken-4"
                  small
                  title="Habilitar"
                  @click="cambiaEstado(props.item.id)"
                >
                  <v-icon>toggle_on</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <!-- leyenda -->
            <v-btn depressed outline icon fab dark color="primary" small>
              <v-icon>open_in_new</v-icon> </v-btn
            >&nbsp;Editar pestaña&nbsp;&nbsp;&nbsp;
            <v-btn depressed outline icon fab dark color="grey darken-4" small>
              <v-icon>toggle_on</v-icon> </v-btn
            >&nbsp;Habilitar&nbsp;&nbsp;&nbsp;
            <v-btn depressed outline icon fab dark color="green darken-4" small>
              <v-icon>toggle_off</v-icon> </v-btn
            >&nbsp;Deshabilitar
          </v-card-actions>

          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="cantRegistros"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="text-center pt-2">
            <v-pagination
              @input="changePage(page)"
              v-model="page"
              :length="pageCount"
              :total-visible="9"
              circle
            >
            </v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <!-- Dialog -->
      <v-form ref="form" lazy-validation>
        <v-dialog v-model="dialog" max-width="500">
          <v-card>
            <v-flex xs10 class="mx-4">
              <v-card-title class="headline" style="font-weight: bold"
                >Edición pestaña</v-card-title
              >
              <v-text-field
                v-model="descripcion"
                :error-messages="descripcionErrors"
                label="Descripción de tipo de producto"
                counter="20"
                maxlength="20"
                :box="tipeView == 'consulta'"
                :readonly="tipeView == 'consulta'"
                @input="$v.descripcion.$touch()"
                @blur="tipeView == 'crear' ? $v.descripcion.$touch() : null"
              ></v-text-field>
              <v-select
                v-model="ordenValue"
                item-text="name"
                item-value="code"
                :items="ordenSelect"
                label="Orden"
              ></v-select>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="indigo darken-1"
                  flat="flat"
                  @click="cerrarDialog"
                >
                  Cancelar</v-btn
                >
                <v-btn
                  color="indigo darken-1"
                  flat="flat"
                  @click="savePestanna()"
                  >Guardar</v-btn
                >
              </v-card-actions>
            </v-flex>
          </v-card>
        </v-dialog>
      </v-form>
    </div>
  </v-container>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import jwtDecode from "jwt-decode";

export default {
  name: "grid-administracion-pestanas",

  components: {
    Loading,
    AlertEmpty,
  },
  mixins: [validationMixin],
  validations: {
    descripcion: { required },
  },
  props: {
    tipeView: String,
  },

  data() {
    return {
      usuarioLoggedType: "",
      codigoRol: "",
      loading: false,
      dialog: false,
      alerta: false,
      idContrato: "",
      idPestana: -1,
      descripcion: "",
      ordenValue: -1,
      ordenSelect: [],
      itemsPestanas: [],
      headers: [
        { text: "Descripción", sortable: false, value: "descripcion" },
        { text: "Orden", sortable: false, value: "orden" },
        { text: "Estado", sortable: false, value: "estado" },
        {
          text: "Fecha Actualización",
          sortable: false,
          value: "fechaActualizacion",
        },
        { text: "Acción", sortable: false, value: "" },
      ],
      rowsPerPageItems: [20],
      search: "",
      page: 1,
      pageCount: 0,
      datosPaginados: [],
      paginaActual: 1,
      cantRegistros: 0,
    };
  },
  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.usuarioLoggedType = this.$store.getters.userLogged.tipo;
    this.codigoRol = this.$store.getters.rolIncontractStored.codigoRol;

    this.loadData();
  },

  mounted() {},
  computed: {
    descripcionErrors() {
      const errors = [];
      if (!this.$v.descripcion.$dirty) return errors;
      !this.$v.descripcion.required &&
        errors.push("Descripción es obligatorio.");
      return errors;
    },
  },
  methods: {
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.id === this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      return user.perfil.codigo;
    },
    cerrarDialog() {
      this.dialog = false;
      this.descripcion = "";
      this.ordenValue = -1;
    },
    submit() {
      this.$v.$touch();
    },

    async loadPestanasFilter() {
      this.body = {
        idContrato: this.idContrato,
      };
      return await axios
        .post("/productoReporte/pestanas", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          } else {
            console.log("error loadPestanasFilter");
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;
      this.itemsPestanas = await this.loadPestanasFilter();

      if (this.itemsPestanas.length > 0) {
        this.cantRegistros = this.itemsPestanas.length;
        this.pageCount = Math.ceil(
          this.itemsPestanas.length / this.rowsPerPageItems
        ); // dsoto 09-11-2022
        this.getDataPagina(this.page); // dsoto 09-11-2022
        this.alerta = false;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },

    // dsoto 09-11-2022
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.getDataPagina(this.page);
    },

    getDataPagina(noPagina) {
      this.paginaActual = noPagina;
      this.datosPaginados = [];

      let ini = noPagina * this.rowsPerPageItems - this.rowsPerPageItems;
      let fin = noPagina * this.rowsPerPageItems;
      this.datosPaginados = this.itemsPestanas.slice(ini, fin);
    },
    // dsoto 09-11-2022

    savePestanna() {
      this.dialog = false;
      if (
        this.descripcion == undefined ||
        this.descripcion == null ||
        this.descripcion == ""
      ) {
        window.getApp.$emit("DATOS_INCOMPLETOS");
        return;
      }
      this.loading = true;
      this.body = {
        id: this.idPestana,
        idContrato: this.idContrato,
        descripcion: this.descripcion,
        orden: this.ordenValue,
      };

      axios
        .post("/productoReporte/pestanaSave", this.body)
        .then(() => {
          window.getApp.$emit("APP_SAVE");
          this.itemsPestanas = [];
          this.descripcion = "";
          this.ordenValue = -1;
          this.loadData();
          this.$emit("load-pestanas-func");
        })
        .catch((error) => {
          console.log("error:" + JSON.stringify(error, null, 2));
          if (error) {
            console.log("falla savePestanna:" + error.response);
          } else {
            console.log("error savePestanna");
          }
          window.getApp.$emit("ERROR_EXCEPTION_BACK");
          this.loading = false;
        });
    },

    cambiaEstado(idPestanna) {
      this.loading = true;
      this.body = {
        id: idPestanna,
        idContrato: this.idContrato,
      };
      axios
        .post("/productoReporte/pestanaCambioEstado", this.body)
        .then(() => {
          window.getApp.$emit("APP_SAVE");
          this.$emit("load-pestanas-func");
          this.itemsPestanas = [];
          this.loadData();
          this.loading = false;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response);
          } else {
            console.log("error cambiaEstado");
          }
          window.getApp.$emit("ERROR_EXCEPTION_BACK");
          this.loading = false;
        });
    },

    crearPestana() {
      this.idPestana = -1;
      this.descripcion = "";

      this.ordenSelect = [];
      for (var i = 1; i <= this.itemsPestanas.length + 1; i++)
        this.ordenSelect.push(i);
      this.ordenValue = this.itemsPestanas.length + 1;

      this.dialog = true;
    },

    editarPestana(id, descripcion, orden) {
      this.idPestana = id;
      this.descripcion = descripcion;
      this.ordenValue = orden;

      this.ordenSelect = [];
      for (var i = 1; i <= this.itemsPestanas.length; i++)
        this.ordenSelect.push(i);
      this.dialog = true;
    },
  },
};
</script>
